<template>
  <div class="text-left">
    <b-form @submit.prevent="save">
      <div class="row">
        <div class="col-md-6">
          <b-form-group
            id="input-group-fullName"
            :label="`Full name`"
            label-for="input-fullName"
          >
            <b-form-input
              v-model="model.applicant.fullName"
              :id="`input-fullName`"
              :type="`text`"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            id="input-group-emailAddress"
            :label="`Email address`"
            label-for="input-emailAddress"
          >
            <b-form-input
              v-model="model.applicant.emailAddress"
              :id="`input-emailAddress`"
              :type="`email`"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            id="input-group-birthDate"
            :label="`Birth date`"
            label-for="input-birthDate"
          >
            <b-form-input
              v-model="model.applicant.birthDate"
              :id="`input-birthDate`"
              :type="`date`"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            id="input-group-mobilePhone"
            :label="`Mobile (optional)`"
            label-for="input-mobilePhone"
          >
            <b-form-input
              v-model="model.applicant.mobilePhone"
              :id="`input-mobilePhone`"
              :type="`text`"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6" v-if="false">
          <div class="mb-3">
            <label for="input-group-birthCountry">Birth country</label>
            <div class="mb-3">
              <v-select
                id="input-group-birthCountry"
                v-model="model.applicant.birthCountry"
                :options="countries"
                label="country_name"
              >
                <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!model.applicant.birthCountry"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="col-md-6" v-if="!model.euApplicant">
          <div class="mb-3">
            <label for="input-group-nationality">Nationality</label>
            <div class="mb-3">
              <v-select
                id="input-group-nationality"
                v-model="model.applicant.nationality"
                :options="nationals"
              >
                <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!model.applicant.nationality"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <b-form-group
            id="input-group-gender"
            label="Gender"
            label-for="input-gender"
            description=""
          >
            <b-form-select
              id="input-gender"
              v-model="model.applicant.gender"
              required
            >
              <b-form-select-option
                :value="c"
                v-for="(c, i) in getGenderOptions"
                :key="`gender-${i}`"
              >
                {{ c | capitalize }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            id="input-group-englishProficiency"
            :label="`English proficiency (optional)`"
            label-for="input-englishProficiency"
          >
            <b-form-input
              v-model="model.applicant.englishProficiency"
              :id="`input-englishProficiency`"
              :type="`text`"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6" v-if="!model.euApplicant && !excludeAgentField">
          <b-form-group
            id="input-group-agentName"
            :label="`Agent name`"
            label-for="input-agentName"
          >
            <b-form-input
              v-model="model.applicant.agentName"
              :id="`input-agentName`"
              :type="`text`"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <hr />
      <div class="my-3">
        <div class="row">
          <div class="col-6">
            <h3 v-if="getBooking && false" id="calculatedPrice">
              Total: &euro;{{ getBooking.totalAmount | round }}
            </h3>
          </div>
          <div class="col text-right">
            <b-button
              v-if="getBooking.step > getBooking.firstStep"
              type="button"
              variant="default"
              @click="back()"
              >Back</b-button
            >
            <b-button type="submit" variant="primary">Next</b-button>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "../../filters";

export default {
  name: "BookingApplicant",
  data() {
    return {
      model: null,
    };
  },
  components: {},
  computed: {
    ...mapGetters(["getBooking", "getSettings", "getGenderOptions"]),
    countries: function() {
      let vm = this;
      return vm.getSettings ? vm.getSettings.countries : [];
    },
    nationals: function() {
      let vm = this;
      return vm.getSettings ? vm.getSettings.nationals : [];
    },
    excludeAgentField: function() {
      let vm = this;
      return (
        vm.getSettings &&
        vm.getSettings.excludeBookingFields &&
        vm.getSettings.excludeBookingFields.agentName
      );
    },
  },
  methods: {
    ...mapActions(["saveBooking", "moveBookingBack", "moveBookingNext"]),
    save() {
      this.next();
    },
    back() {
      // go back
      //const thisStep = this.model.step ? this.model.step : 1;
      //if (thisStep > this.model.firstStep) this.model.step = thisStep - 1;
      this.saveBooking(this.model);
      this.moveBookingBack();
      return false;
    },
    next() {
      // go to next
      //const thisStep = this.model.step ? this.model.step : 1;
      //if (thisStep < this.model.lastStep) this.model.step = thisStep + 1;
      this.model.existingStudent = false;
      this.saveBooking(this.model);
      this.moveBookingNext();
      return false;
    },
  },
  created() {
    let vm = this;
    if (vm.getBooking) {
      vm.model = JSON.parse(JSON.stringify(vm.getBooking));

      if (vm.model.applicant && vm.model.applicant.originCountry == "") {
        vm.model.applicant.originCountry = vm.getSettings
          ? vm.getSettings.defaultCountry
          : "";
      }
      if (vm.model.applicant && vm.model.applicant.birthCountry == "") {
        vm.model.applicant.birthCountry = vm.getSettings
          ? vm.getSettings.defaultCountry
          : "";
      }
      if (vm.model.applicant && vm.model.applicant.country == "") {
        vm.model.applicant.country = vm.getSettings
          ? vm.getSettings.defaultCountry
          : "";
      }
      if (vm.model.applicant && vm.model.applicant.passportIssueCountry == "") {
        vm.model.applicant.passportIssueCountry = vm.getSettings
          ? vm.getSettings.defaultCountry
          : "";
      }
      if (vm.model.applicant && vm.model.applicant.nationality == "") {
        vm.model.applicant.nationality = vm.getSettings
          ? vm.getSettings.defaultNationality
          : "";
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
